export const parseSupportDate = (value: string): Date => {
    const normalized = value.trim();
    const naiveTimestamp = /^\d{4}-\d{2}-\d{2}[T ]\d{2}:\d{2}(?::\d{2}(?:\.\d+)?)?$/.test(normalized);
    return new Date(naiveTimestamp ? `${normalized.replace(' ', 'T')}Z` : normalized);
};

export const formatSupportDate = (value?: string): string => {
    if (!value) return '-';
    const date = parseSupportDate(value);
    if (Number.isNaN(date.getTime())) return '-';
    return date.toLocaleString('ru-RU', { timeZone: 'UTC' });
};
